export const populateDate = (currentOrder, loc) => {
  const today = new Date().toISOString().split("T")[0];

  const isValidDate = d =>
    typeof d === "string" && d.trim() !== "" && !isNaN(new Date(d));

  const locations = Array.isArray(currentOrder?.locations)
    ? currentOrder.locations
    : [];

  // ------------------------------------
  // 1. COMPLETED → authoritative local date
  // ------------------------------------
  if (loc?.status === "COMPLETED") {
    const directDate = loc?.appointment?.appt_date;

    if (isValidDate(directDate)) {
      return directDate;
    }

    const fallbackDate = loc?.appointments
      ?.find(a => isValidDate(a?.appt_date))
      ?.appt_date;

    return fallbackDate || today;
  } 

  //-------------------------------------
  // 2. Check if the loc has an appointment date already
  // ------------------------------------
  if (isValidDate(loc?.appointment?.appt_date)) {
    return loc.appointment.appt_date;
  }

  const fallbackDate = loc?.appointments
    ?.find(a => isValidDate(a?.appt_date))
    ?.appt_date;

  if (fallbackDate) {
    return fallbackDate;
  }

  // ------------------------------------
  // 3. Collect all valid dates (appointment + appointments)
  // ------------------------------------
  const validDates = locations.flatMap(l => {
    const dates = [];

    // latest single-object edit
    if (isValidDate(l?.appointment?.appt_date)) {
      dates.push(l.appointment.appt_date);
    }

    // historical / bulk appointments
    if (Array.isArray(l?.appointments)) {
      l.appointments.forEach(a => {
        if (isValidDate(a?.appt_date)) {
          dates.push(a.appt_date);
        }
      });
    }

    return dates;
  });

  // ------------------------------------
  // 4. No valid dates → today
  // ------------------------------------
  if (validDates.length === 0) {
    return today;
  }

  // ------------------------------------
  // 5. Earliest valid date
  // ------------------------------------
  return validDates.reduce((earliest, current) =>
    new Date(current) < new Date(earliest) ? current : earliest
  );
};
